export default {
    formId: 'editarExpressCheckinForm', //'checkoutForm',
    formField: {
      e_code: {
        name: 'e_code',
        label: 'Codigo Reserva*',
        requiredErrorMsg: 'El codigo de reserva es requerido.'
      },
      e_adults: {
        name: 'e_adults',
        label: 'Cantidad Adultos*',
        requiredErrorMsg: 'La cantidad de adultos es requerido.'
      },
      e_minors: {
        name: 'e_minors',
        label: 'Cantidad Menores*',
        requiredErrorMsg: 'La cantidad de menores es requerido.'
      },
      e_arrival: {
        name: 'e_arrival',
        label: 'Fecha Llegada*',
        requiredErrorMsg: 'La fecha llegada es requerida.'
      },
      e_departure: {
        name: 'e_departure',
        label: 'Fecha Salida*',
        requiredErrorMsg: 'La fecha salida es requerida.'
      },
      e_bussines: {
        name: 'e_bussines',
        label: '¿Reserva Empresarial?',
        requiredErrorMsg: 'La fecha salida es requerida.'
      },
    }
};
